import { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { adminApi } from '../lib/api'

export function ProtectedAdmin() {
  const [state, setState] = useState<'loading' | 'allowed' | 'denied'>('loading')

  useEffect(() => {
    let active = true
    supabase.auth.getSession().then(async ({ data }) => {
      if (!active) return
      if (!data.session) { setState('denied'); return }
      const allowed = await adminApi.isAdmin()
      if (active) setState(allowed ? 'allowed' : 'denied')
    })
    return () => { active = false }
  }, [])

  if (state === 'loading') return <div className="page-message">Validando acesso...</div>
  if (state === 'denied') return <Navigate to="/admin/login" replace />
  return <Outlet />
}
